var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background1"},[_vm._v(" Just do it")])
}
var staticRenderFns = []

export { render, staticRenderFns }